import { render } from "./MonthlyTotalsChart.vue?vue&type=template&id=648ebb26"
import script from "./MonthlyTotalsChart.vue?vue&type=script&lang=js"
export * from "./MonthlyTotalsChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__